<template>
  <v-app id="app">
    <div v-if="isAuthenticated">
      <v-navigation-drawer v-model="drawer" fixed app :clipped="$vuetify.breakpoint.lgAndUp">
        <v-list dense>
          <v-list-item to="/home">
            <v-list-item-action>
              <v-icon>mdi-home</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="user_type == 'admin' || user_type == 'sp_sp'" to="/socialne_podniky">
            <v-list-item-action>
              <v-icon>mdi-domain</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Sociálne podniky - klienti</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="user_type == 'admin' || user_type == 'sp_centrum'" to="/socialne_podniky_users">
            <v-list-item-action>
              <v-icon>mdi-domain</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Sociálne podniky - používatelia</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="user_type == 'default' || user_type == 'admin'" to="/crcra">
            <v-list-item-action>
              <v-icon>mdi-alert</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>CRA</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="user_type == 'default' || user_type == 'upsvar' || user_type=='probacia' || user_type == 'admin'" to="/iapsz">
            <v-list-item-action>
              <v-icon>mdi-run</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>IAPSZ</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group v-if="user_type == 'default' || user_type == 'lektor' || user_type == 'admin'"
            prepend-icon="mdi-view-sequential">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Všeobecné</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-list-item v-if="user_type == 'admin' || user_type == 'lektor'" to="/general/zavislosti_pred/">
              <v-list-item-action>
                <v-icon>mdi-file-document</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>ŠRaVVP Závislosti pred</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="user_type == 'admin' || user_type == 'lektor'" to="/general/zavislosti_po/">
              <v-list-item-action>
                <v-icon>mdi-file-document</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>ŠRaVVP Závislosti po</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/general/skaly_pred/">
              <v-list-item-action>
                <v-icon>mdi-file-document</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>ZRaVVP vstup. hodnotenie</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/general/skaly_po">
              <v-list-item-action>
                <v-icon>mdi-file-document</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>ZRaVVP výstup. hodnotenie</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item to="/general/testy">
              <v-list-item-action>
                <v-icon>mdi-file-document</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Testy</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="user_type == 'admin' || user_type == 'lektor'" to="/general/segregovanekomunity_pred/">
              <v-list-item-action>
                <v-icon>mdi-file-document</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Seg. komun. vstup. hodnotenie
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="user_type == 'admin' || user_type == 'lektor'" to="/general/segregovanekomunity_po/">
              <v-list-item-action>
                <v-icon>mdi-file-document</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Seg. komun. vystup. hodnotenie
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-group v-if="user_type != 'sp_sp' && user_type != 'sp_centrum'" prepend-icon="mdi-infinity">
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Administrácia</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-list-item to="/admin/users" v-if="user_type != 'sp_centrum'">
              <v-list-item-action>
                <v-icon>mdi-account-group-outline</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Používatelia</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="user_type == 'admin'" to="/admin/prisoners">
              <v-list-item-action>
                <v-icon>mdi-account-group</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Odsúdení</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="user_type == 'admin'" to="/admin/search">
              <v-list-item-action>
                <v-icon>mdi-account-search</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Vyhľadávač</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="user_type == 'admin'" to="/admin/institutions">
              <v-list-item-action>
                <v-icon>mdi-domain</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Inštitúcie</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="user_type == 'admin'" to="/admin/statistics/tables">
              <v-list-item-action>
                <v-icon>mdi-chart-bar</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Tabuľky</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="user_type == 'admin'" to="/admin/statistics/graphs">
              <v-list-item-action>
                <v-icon>mdi-table-search</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Grafy</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="user_type == 'admin'" to="/admin/statistics/graphs_details">
              <v-list-item-action>
                <v-icon>mdi-table-search</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Grafy detaily</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="user_type == 'admin'" @click="craExport()">
              <v-list-item-action>
                <v-icon>mdi-export</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Export CRA</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="user_type == 'admin'" @click="iapszExport()">
              <v-list-item-action>
                <v-icon>mdi-export</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Export IAPSZ</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item to="/about" v-if="user_type != 'sp_sp' || user_type != 'sp_centrum' || user_type != 'probacia'">
            <v-list-item-action>
              <v-icon>mdi-information</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>About</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </div>
    <v-app-bar dense color="indigo" dark fixed app :clipped-left="$vuetify.breakpoint.lgAndUp">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>Nástroje ŠNN</v-toolbar-title>
      <div class="flex-grow-1" />
      <div v-if="isAuthenticated">
        <v-btn text disabled>
          {{ username }}
        </v-btn>
        <v-btn icon @click="showDialog">
          <v-icon>mdi-account-circle</v-icon>
        </v-btn>
        <v-btn icon @click="logout">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </div>
    </v-app-bar>
    <v-main>
      <!-- <v-container> -->
      <router-view />
      <!-- </v-container> -->
    </v-main>

    <v-dialog v-model="dialog" width="800px">
      <v-card>
        <v-card-title>Zmena používateľa</v-card-title>

        <v-container grid-list-sm>
          <v-layout wrap>
            <v-flex xs12>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="new_item.email" label="Email" />
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field v-model="new_item.first_name" label="Meno" />
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field v-model="new_item.last_name" label="Priezvisko" />
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field v-model="new_item.password" label="Heslo" autocomplete="new-password"
                    :append-icon="value ? 'mdi-eye' : 'mdi-account-key'" :type="value ? 'password' : 'text'"
                    @click:append="() => (value = !value)" />
                </v-col>
              </v-row>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn text color="primary" @click="dialog = false">
            Zrušiť
          </v-btn>
          <v-btn text @click="updateItem">
            Zmeniť
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar_success" color="success" :timeout="3000">
      Zmenené
      <v-btn text @click="snackbar_success = false">
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="isError" color="error" :timeout="30000">
      <ul style="list-style-type: none">
        <li v-for="(val, index) in getErrorMessage" :key="index">
          <span v-if="index != 'non_field_errors'"> {{ index }}: </span>
          <span v-if="val instanceof Array">
            {{ val[0] }}
          </span>
          <span v-else>
            {{ val }}
          </span>
        </li>
      </ul>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="dismissError">
          Zavrieť
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import { APIService } from "./http/APIService.js";
import auth from "./api/auth";

const apiService = new APIService();

export default {
  data: () => ({
    drawer: null,
    dialog: false,
    snackbar_success: false,
    value: true,

    new_item: {
      username: "",
      email: "",
      first_name: "",
      last_name: "",
      institution: "",
      type: "",
      password: "",
    },
  }),

  computed: {
    ...mapGetters("auth", ["isAuthenticated", "username", "user_type"]),

    ...mapGetters("notifications", ["isError", "getErrorMessage"]),
  },

  methods: {
    dismissError() {
      this.$store.commit("notifications/dismissError");
    },
    showDialog() {
      this.dialog = true;
      auth
        .getAccountDetails()
        .then((response) =>
          apiService
            .getUser(response.data.pk)
            .then((response) => (this.new_item = response))
        );
    },
    logout() {
      this.$store
        .dispatch("auth/logout", {})
        .then(() => this.$router.push("/login"));
    },
    craExport() {
      apiService.getCrCraExport();
    },
    iapszExport() {
      apiService.getIapszExport();
    },
    updateItem() {
      if (this.new_item.password == "") delete this.new_item.password;

      apiService.updateUser(this.new_item).then(() => {
        this.snackbar_success = true;
        this.getUsers();

        this.new_item.username = "";
        this.new_item.email = "";
        this.new_item.first_name = "";
        this.new_item.last_name = "";
        this.new_item.institution = "";
        this.new_item.type = "";
        this.new_item.password = "";

        this.dialog = false;
        this.update = false;
      });
    },
  },
};
</script>